export enum PortalSetupMenuItems {
  MACHINE_CATEGORIES = 'machine_categories'
}